export default __webpack_public_path__ + "static/media/3314.87b38045.png";